/*
 * <free-shipping-bar>
 * The markup is re-rendered by the cart (drawer or page) after every change.
 * When the new element connects, we animate the fill from the previous
 * percentage to the new one so the bar moves smoothly instead of jumping.
 */
if (!customElements.get('free-shipping-bar')) {
  class FreeShippingBar extends HTMLElement {
    connectedCallback() {
      const fill = this.querySelector('.fsb__fill');
      const target = parseFloat(this.dataset.percent) || 0;
      const previous = window.__freeShippingBarLast;
      window.__freeShippingBarLast = target;

      const reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (!fill || reduceMotion || typeof previous !== 'number' || previous === target) return;

      fill.style.transition = 'none';
      fill.style.width = previous + '%';
      fill.getBoundingClientRect(); // force reflow so the next change animates

      requestAnimationFrame(() => {
        fill.style.transition = '';
        fill.style.width = target + '%';
      });
    }
  }

  customElements.define('free-shipping-bar', FreeShippingBar);
}